import { fabric } from "fabric"
import {BACKGROUND_THEME_IMAGE_MULTIPLE_PREFIX_ID} from '../../constants/templates-field-prefixes'

export default class BackgroundThemeImageMultiple {
    templateData = null
    templateField = null
    inputData = null
    object = null
    id = null
    order = 0

    constructor(templateField, inputData, templateData) {
      this.templateField = templateField
      this.inputData = inputData
      this.templateData = templateData
      this.id = inputData.getId()
    }

    async _initObject() {
      this.object = await new Promise((resolve) => {
        fabric.Image.fromURL(this.inputData.getUrl(), (oImg) => {
          resolve(oImg)
        })
      })
    }

    getTemplateAndInputDataId() {
      return `${this.templateField.getId()}-${this.getId()}`
    }

    getId() {
      return this.id
    }

    getObjectId() {
      return BACKGROUND_THEME_IMAGE_MULTIPLE_PREFIX_ID + this.id
    }

    getSizeObject() {
      let width = this.templateField.getWidth();
      let height = this.templateField.getHeight();
      
      if (!height && width) {
        height = width / (this.object.width / this.object.height)
      }
      if(height && !width) {
        width = height / (this.object.height / this.object.width)
      }

      if (!width) {
        width = this.object.width;
      }
      if (!height) {
        height = this.object.height;
      }

      return { width, height }
    }

    getcCoordinate() {
      const left = this.inputData.get('x', this.templateField.getLeft());
      const top = this.inputData.get('y', this.templateField.getTop());

      return { left, top }
    }

    getScale() {
      const { width, height } = this.getSizeObject()
      let scaleX = this.inputData.get('scaleX', width / this.object.width);
      let scaleY = this.inputData.get('scaleY', height / this.object.height);

      if (this.templateField.isFill()) {
        if (
          this.templateData.width / this.object.width >
          this.templateData.height / this.object.height
        ) {
          scaleX = this.templateData.width / width;
          scaleY = scaleX;
        } else {
          scaleX = this.templateData.height / height
          scaleY = scaleX;
        }
      }
      
      return { scaleX, scaleY }
    }

    getConfig() {
      const { width, height } = this.getSizeObject()
      const { left, top } = this.getcCoordinate()
      const { scaleX, scaleY } = this.getScale()
      
      let config = {
        id: this.getObjectId(),
        element_id: this.getObjectId(),
        inputDataId: this.id,
        order: this.templateField.getOrder() + this.order,
        left,
        top,
        originX: "left",
        originY: "top",
        scaleX,
        scaleY,
        selectable: this.templateField.isMoveable(),
        evented: this.templateField.isMoveable(),
        real_id: this.templateField.getId(),
        templateAndInputDataId: this.getTemplateAndInputDataId(), 
        angle: this.inputData.get('angle', 0),
        groupName: this.templateField.getGroupName(),
      };

      if (this.templateField.isCrop()) {
        config = {
          ...config,
          cropX: 0,
          cropY: 0,
          scaleX,
          scaleY,
          width,
          height,
        }
      }

      return config
    }

    async render() {
      await this._initObject()
      
      const config = this.getConfig()

      this.object.set(config)
      this.object.setControlsVisibility({
        tr: true,
        br: true,
        bl: true,
        ml: !false,
        mt: !false,
        mr: !false,
        mb: !false,
        mtr: true,
      });

      return this.object
    }

    update() {
      if (!this.object) return
      this.object.set(this.getConfig())
    }

    removeObjects(canvas) {
      canvas.remove(this.object)

      return this
    }
}